import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accordion-header" }
const _hoisted_2 = ["data-bs-target", "aria-controls"]
const _hoisted_3 = { class: "container-fluid p-0" }
const _hoisted_4 = { class: "row w-100" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "accordion-body" }
const _hoisted_12 = { class: "container-fluid p-0" }
const _hoisted_13 = { class: "row w-100" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "row w-100" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "row w-100" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "row w-100" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "incident-details mx-2 mt-3" }
const _hoisted_28 = { class: "description-text" }
const _hoisted_29 = { class: "row mt-3" }
const _hoisted_30 = { class: "col text-end" }

import { ref } from 'vue';
import type { Incident } from '@/types/incidentsTypes';

import { useIncidentStore } from '@/stores/useIncidentStore';
import { Pencil, Square } from 'lucide-vue-next';

import { Wrench, UserRound, Phone, CalendarClock } from 'lucide-vue-next';
import { Calculator, Store, SquareCheck, KeyRound } from 'lucide-vue-next';

import IncidentFormComponent from './IncidentFormComponent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IncidentItemComponentAux',
  props: {
    incident: {}
  },
  setup(__props: any) {

const props = __props;
const incidentStore = useIncidentStore();

const isEditFormModalOpen = ref(false);
const editingIncident = ref<Incident | null>(null);

// Función para formatear la fecha y la hora
const formatDateTime = (date: string | null | undefined, time: string | null | undefined): string => {
  if (!date) return "N/A";

  let formattedDate = new Date(date).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  
  let formattedTime = time ? time.slice(0, 5) : "";

  return time ? `${formattedDate} ${formattedTime}` : formattedDate;
};

const openEditFormModal = (incident: Incident) => {
  console.log("Operator Name: " + incident.operator_name)
  editingIncident.value = incident;
  isEditFormModalOpen.value = true;
};

const handleCloseEditFormModal = () => {
  editingIncident.value = null;
  isEditFormModalOpen.value = false;
};

const handleSubmitEditFormModal = async () => {
  await incidentStore.fetchIncidents();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, [
      _createElementVNode("button", {
        class: "accordion-button collapsed w-100 border-top border-primary",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": `#collapse${_ctx.incident.id}`,
        "aria-expanded": "false",
        "aria-controls": `collapse${_ctx.incident.id}`
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.incident.id), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.incident.expendeduria_name), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.incident.maquina_name), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass(["badge rounded-pill", _ctx.incident.is_resolved ? 'bg-success' : 'bg-danger'])
              }, _toDisplayString(_ctx.incident.is_resolved ? 'Resuelto' : 'Pendiente'), 3)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(formatDateTime(_ctx.incident.incident_date, _ctx.incident.incident_time)), 1)
          ])
        ])
      ], 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      id: `collapse${_ctx.incident.id}`,
      class: "accordion-collapse collapse text-start"
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(KeyRound)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.id), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_unref(SquareCheck)),
              _cache[1] || (_cache[1] = _createTextVNode()),
              _createElementVNode("span", {
                class: _normalizeClass(["badge rounded-pill", _ctx.incident.is_resolved ? 'bg-success' : 'bg-danger'])
              }, _toDisplayString(_ctx.incident.is_resolved ? 'Resuelto' : 'Pendiente'), 3)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(UserRound)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.client_name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_unref(Store)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.expendeduria_name), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_unref(CalendarClock)),
              _createTextVNode(" " + _toDisplayString(formatDateTime(_ctx.incident.incident_date, _ctx.incident.incident_time)), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(Phone)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.client_phone), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_unref(Calculator)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.maquina_name), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_unref(CalendarClock)),
              _createTextVNode(" " + _toDisplayString(formatDateTime(_ctx.incident.resolution_date, _ctx.incident.resolution_time)), 1)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_unref(Wrench)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.operator_name), 1)
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col" }, null, -1)),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[5] || (_cache[5] = _createElementVNode("h5", null, "Descripción:", -1)),
              _createElementVNode("pre", _hoisted_28, _toDisplayString(_ctx.incident.description), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openEditFormModal(_ctx.incident)))
              }, [
                _createVNode(_unref(Pencil)),
                _cache[6] || (_cache[6] = _createTextVNode(" Editar "))
              ])
            ])
          ])
        ])
      ])
    ], 8, _hoisted_10),
    _createVNode(IncidentFormComponent, {
      show: isEditFormModalOpen.value,
      incident: editingIncident.value,
      onClose: handleCloseEditFormModal,
      onSubmit: handleSubmitEditFormModal
    }, null, 8, ["show", "incident"])
  ], 64))
}
}

})